/** imports */
import * as React from 'react'
import { createRoot } from 'react-dom/client'

import graphqlQuery     from 'tsRoot/actions/graphql'
import { getId }        from 'tsRoot/actions/url'
import { projectApply } from 'tsRoot/actions/midworks-freelance/project'
import { getValueFromCookie } from 'tsRoot/actions/cookie'

import { env } from 'tsRoot/constants'

async function getProjectDetails(projectId: string) {
  const query = `
  {
    projects(id: ${projectId}) {
      items {
        id
        hasUserApplied
        settlementTerms
        paymentSiteSetting
        workingPeriodStartDate
        onlineInterview
        recruitmentNumber
      }
    },
  }
  `

  const res = await graphqlQuery(query)
  return res
}

const projectApplicationSideJsx = (loginId: string, projectId: string | number, hasUserApplied: boolean, setState: React.Dispatch<React.SetStateAction<never[]>> ) => {
  const params = new URLSearchParams(window.location.search)
  if(loginId && loginId != 'false' && hasUserApplied) {
    return (
      <div className="c-registrationStatus">
        <div className="c-registrationStatus__header">
          <p className="c-registrationStatus__heading">応募済</p>
        </div>
      </div>
    )
  } else if (loginId && loginId != 'false') {
    projectId && params.append("project_id",String(projectId))
    return (
      <div className="c-registrationStatus">
        <div className="c-registrationStatus__header">
          <p className="c-registrationStatus__heading">お急ぎください！</p>
        </div>
        <div className="c-registrationStatus__content">
          <p className="c-registrationStatus__text">人気の案件はすぐに応募終了になる可能性があります。<br/>まだ検討中の方は、会員登録後にキャリアアドバイザーにご相談ください。</p>
          <a onClick={() => {projectApply(projectId, setState)}} className="c-registrationStatus__button ga_register_side collect-tag-apply-project-detail-side" siteobj-projectid={projectId}>ワンクリック応募</a>
        </div>
      </div>
    )
  } else {
    projectId && params.append("project_id",String(projectId))
    return (
      <div className="c-registrationStatus">
        <div className="c-registrationStatus__header">
          <p className="c-registrationStatus__heading">お急ぎください！</p>
        </div>
        <div className="c-registrationStatus__content">
          <p className="c-registrationStatus__text">人気の案件はすぐに応募終了になる可能性があります。<br/>まだ検討中の方は、会員登録後にキャリアアドバイザーにご相談ください。</p>
          <a href={"/users/registration?" + params} className="c-registrationStatus__button ga_register_side">会員登録して応募する</a>
        </div>
      </div>
    )
  }
}

const projectApplicationUnderJsx = (loginId: string, projectId: string | number, hasUserApplied: boolean, setState: React.Dispatch<React.SetStateAction<never[]>> ) => {
  const params = new URLSearchParams(window.location.search)
  if(loginId && loginId != 'false' && hasUserApplied) {
    return (
      <>
        <div className="p-jobBoard__panel2 --fix08">
          <div>
            <p className="p-jobBoard__text2">応募済</p>
          </div>
        </div>
        <p className="p-jobBoard__caution2">申込の殺到やプロジェクト・企業の情報流出を防ぐため、Web上での情報公開を一部制限しております。Midworksにご登録いただき、カウンセリング面談にて詳しい案件内容をお伝え致します。その際に、ご希望に合わせて他の類似案件もご紹介することが可能です。納得できる案件がなかった場合は、素直にお断り頂いて問題ございませんので、気軽にご相談ください。</p>
      </>
    )
  } else if (loginId && loginId != 'false') {
    return (
      <>
        <div className="p-jobBoard__panel2">
          <div>
            <p className="p-jobBoard__text2">人気案件は申し込みが集中するため、お早めにご相談ください</p>
            <a onClick={() => {projectApply(projectId, setState)}} className="p-jobBoard__button ga_register_projectsdetail collect-tag-apply-project-detail-bottom" siteobj-projectid={projectId}>ワンクリック応募</a>
          </div>
        </div>
        <p className="p-jobBoard__caution2">申込の殺到やプロジェクト・企業の情報流出を防ぐため、Web上での情報公開を一部制限しております。Midworksにご登録いただき、カウンセリング面談にて詳しい案件内容をお伝え致します。その際に、ご希望に合わせて他の類似案件もご紹介することが可能です。納得できる案件がなかった場合は、素直にお断り頂いて問題ございませんので、気軽にご相談ください。</p>
      </>
    )
  } else {
    projectId && params.append("project_id",String(projectId))
    return (
      <>
        <div className="p-jobBoard__panel2">
          <div>
            <p className="p-jobBoard__text2">人気案件は申し込みが集中するため、お早めにご相談ください</p>
            <a href={"/users/registration?" + params} className="p-jobBoard__button ga_register_projectsdetail">会員登録して応募する</a>
          </div>
        </div>
        <p className="p-jobBoard__caution2">申込の殺到やプロジェクト・企業の情報流出を防ぐため、Web上での情報公開を一部制限しております。Midworksにご登録いただき、カウンセリング面談にて詳しい案件内容をお伝え致します。その際に、ご希望に合わせて他の類似案件もご紹介することが可能です。納得できる案件がなかった場合は、素直にお断り頂いて問題ございませんので、気軽にご相談ください。</p>
      </>
    )
  }
}

const projectApplicationRegisterButtonRender = (loginId: string, projectId: string | number, hasUserApplied: boolean, setState: React.Dispatch<React.SetStateAction<never[]>> ) => {
  const params = new URLSearchParams(window.location.search)
  if(loginId && loginId != 'false' && hasUserApplied) {
    return (
      <>
        <div className="is-hide-pc p-jobBoard__panel3">
          <div>
            <p className="p-jobBoard__text2">応募済</p>
          </div>
        </div>
      </>
    )
  } else if (loginId && loginId != 'false') {
    return (
      <>
        <a onClick={() => {projectApply(projectId, setState)}} className="p-jobBoard__button ga_register_projectsdetail is-hide-pc">ワンクリック応募</a>
      </>
    )
  } else {
    projectId && params.append("project_id",String(projectId))
    return (
      <>
        <a href={"/users/registration?" + params} className="p-jobBoard__button ga_register_projectsdetail is-hide-pc">会員登録して応募する</a>
      </>
    )
  }
}


const projectDetailsRender = async(setState: React.Dispatch<React.SetStateAction<never[]>>) => {
  const projectId = getId()
  const res = await getProjectDetails(projectId)
  const project = res.projects.items[0]
  const loginId = getValueFromCookie(`midworks_mypage_${env}_login`)

  // 会員登録して応募する
  const projectApplyRegisterElements = document.getElementsByClassName('projectApplyRegister')
  for (let element of projectApplyRegisterElements) {
    if(element) createRoot(element).render(projectApplicationRegisterButtonRender(loginId, projectId, project.hasUserApplied, setState))
  }

  // 案件応募
  const projectApplySideElement = document.getElementById('projectApplySide')
  if(projectApplySideElement) createRoot(projectApplySideElement).render(projectApplicationSideJsx(loginId, projectId, project.hasUserApplied, setState))
  const projectApplyUnderElement = document.getElementById('projectApplyUnder')
  if(projectApplyUnderElement) createRoot(projectApplyUnderElement).render(projectApplicationUnderJsx(loginId, projectId, project.hasUserApplied, setState))
}

/** エクスポートするJSXのコンポーネント */
export const Main = () => {
  const [applyId, setApplyId] = React.useState([]) // 案件応募を行った際のIDを格納して再rendorを行う

  React.useEffect(() => {
    projectDetailsRender(setApplyId)
  }, [applyId])

  // useEffectのReactDOMでviewの一部分だけ書き換えるようにreactを使っているため、ここではreturnを空で返す
  return (<></>);
}
